// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const sw: ChromeTranslations = {
  'nav.nextPage': 'ukurasa unaofuata →',
  'nav.previousPage': '← ukurasa uliopita',
  'nav.continueToLevel': 'endelea kwa kiwango →',
  'nav.backToMenu': 'rudi kwa menyu →',
  'howto.page': 'ukurasa wa {n} kati ya {total}',
  'options.title': 'Chaguzi',
  'ui.language': 'Lugha',
};
